import Grid from '@mui/material/Grid';
import { withStyles } from 'utils/styles';
import SpinButton from 'components/Buttons/SpinButton';
import BaseTable from 'components/Tables/BaseTable';
import { alertError } from 'ducks/alerts';
import { passwordUpdate } from 'ducks/auth';
import { actions as userActions } from 'ducks/users';
import NewPasswordDialog from 'pages/AppBarMenu/UserData/NewPasswordDialog';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import theme from 'source/theme';
import columns from 'utils/tables/columns/userData';
import { currentAccount, currentUser } from 'selectors/currentUser';

const styles = theme => ({
  text: {
    marginBottom: theme.spacing(1)
  }
});

const Component = props => {
  const { account, classes, user } = props;
  const { updatePassword, update } = props;

  const [submitting, setSubmitting] = useState(false);

  const [userPassword, setUserPassword] = React.useState(false);

  const handleClose = () => {
    setUserPassword(false);
  };

  const handleSubmit = (newPassword) => {
    updatePassword(newPassword);
  };

  const userData = [{ ...user, name: account.name }];

  return (
    <Grid size={12}>
      <NewPasswordDialog
        open={userPassword}
        name={user.username}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
      />
      <BaseTable
        columns={columns(user)}
        data={userData}
        options={{
          search: false,
          toolbar: false,
          pageSize: 5,
          maxBodyHeight: null,
          minBodyHeight: null
        }}
        editable={{
          // Only the three fields this page can edit. It used to send the whole
          // row back, which included administrator and everything else the API reads
          // but does not accept from here.
          onRowUpdate: (newData, oldData) => update({
            name: newData.name,
            email: newData.email
          }, user.id)
        }}
      />
      <Grid size={12} style={{ padding: theme.spacing(3) }}>
        <div className={classes.text}>
          Para modificar a sua password:
        </div>
        <SpinButton
          color='primary'
          label='Renovar Password'
          onClick={() => setUserPassword(true)}
          submitting={submitting}
        />
      </Grid>
    </Grid>
  );
};


const mapStateToProps = state => ({
  user: currentUser(state),
  // The caller's own row, out of the scoped `/accounts/` collection. It used
  // to come from a separate `/user_account/` fetch holding a second copy.
  account: currentAccount(state)
});

const mapDispatchToProps = dispatch => ({
  alertError: error => dispatch(alertError(error)),
  updatePassword: newPassword => dispatch(passwordUpdate(newPassword)),
  // Editing your own row is editing a row of /users/, which is the point of
  // there being one place a user lives. `ownUpdate` and the /profile/ duck it
  // belonged to are gone.
  update: (data, id) => dispatch(userActions.updatePromise(id, data))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, theme)(Component));
